import palette from 'lib/styles/palette';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { authSMS } from 'lib/api/auth';
import { useSelector } from 'react-redux';
import { BackArrow } from '../lib/styles/icons';
import client, { serviceClient } from 'lib/api/client';
import { useEffect } from 'react';
import { useRef } from 'react';

const SMSAuthPage = () => {
  const {
    accessToken,
    refreshToken,
    userLevel,
    userType,
    userId,
    username,
    changePassword,
  } = useSelector(({ auth }) => auth);
  const navigate = useNavigate();
  const [tel, setTel] = useState('');
  const [authNumber, setAuthNumber] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [isSend, setSend] = useState(false);
  const [fail, setFail] = useState(false);
  const [time, setTime] = useState(180);
  const intervalIdRef = useRef(null);

  useEffect(() => {
    if (time <= 0) {
      setFail(true);
    }
  }, [time]);

  useEffect(() => {
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  const onSubmit = e => {
    e.preventDefault();
    if (authNumber === authCode) {
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('username', username);
      localStorage.setItem('userLevel', userLevel);
      localStorage.setItem('userType', userType);
      localStorage.setItem('userId', userId);

      client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      serviceClient.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${accessToken}`;

      if (changePassword) {
        navigate(`/reset/${userId}/${userLevel}/${userType}`);
        return;
      }

      if (userLevel === '1') {
        navigate('/service');
      } else {
        navigate('/admin');
      }
    } else {
      setFail(true);
    }
  };

  const onCheck = async () => {
    try {
      const { data } = await authSMS({ tel, id: userId });
      setAuthCode(data.code);
      setSend(true);
      const intervalId = setInterval(() => {
        if (time <= 0) {
          return;
        }
        setTime(prev => prev - 1);
      }, 1000);
      intervalIdRef.current = intervalId;
    } catch (e) {
      setFail(true);
    }
  };

  return (
    <Container>
      <Box>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            width: 330,
            marginTop: 50,
            marginBottom: 30,
          }}
        >
          <div className="logo">2차 인증</div>
          <div
            style={{ position: 'absolute', top: 8, left: 10 }}
            onClick={() => navigate('/')}
          >
            <BackArrow />
          </div>
        </div>
        {fail ? (
          <>
            <div className="fail-text">인증에 실패하였습니다</div>
            <StyledBtn onClick={() => navigate('/')}>확인</StyledBtn>
          </>
        ) : (
          <>
            <div className="wrapper">
              <StyledInput2
                type="tel"
                placeholder="전화번호(' - ' 없이 입력해주세요)"
                autoFocus
                name="tel"
                value={tel}
                onChange={e => setTel(e.target.value)}
              />
              <StyledBtn2 disabled={!tel} onClick={onCheck}>
                확인
              </StyledBtn2>
            </div>
            {isSend && (
              <>
                <div
                  style={{
                    fontStyle: 'italic',
                    color: 'blue',
                    fontSize: 14,
                    marginBottom: 10,
                  }}
                >
                  인증번호가 발송되었습니다.
                </div>
                <div
                  style={{ fontWeight: '700', marginBottom: 10, color: 'red' }}
                >
                  {`${time}초`}
                </div>
              </>
            )}
            <form>
              <StyledInput
                placeholder="인증번호"
                name="authNumber"
                value={authNumber}
                onChange={e => setAuthNumber(e.target.value)}
              />
              <StyledBtn disabled={!authNumber} onClick={onSubmit}>
                확인
              </StyledBtn>
            </form>
          </>
        )}
      </Box>
    </Container>
  );
};

export default SMSAuthPage;

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${palette.background};
`;

const Box = styled.div`
  width: 500px;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);

  .logo {
    font-size: 1.5rem;

    color: ${palette.theme[3]};
    font-weight: 600;
    letter-spacing: 5px;
  }

  form {
    display: flex;
    flex-direction: column;
  }

  .wrapper {
    display: flex;
    margin-bottom: 15px;
    align-items: center;
  }

  .fail-text {
    color: red;
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

const StyledInput = styled.input`
  width: 330px;
  height: 50px;
  padding: 15px;
  border: solid 1px #dfdfdf;
  border-radius: 11px;
  background: #fff;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  & + & {
    margin-top: 15px;
  }
`;

const StyledInput2 = styled.input`
  width: 250px;
  height: 50px;
  padding: 15px;
  border: solid 1px #dfdfdf;
  border-radius: 11px;
  background: #fff;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  & + & {
    margin-top: 15px;
  }
`;

const StyledBtn = styled.button`
  width: 330px;
  height: 50px;
  margin-top: 15px;
  border: none;
  border-radius: 11px;
  background: ${palette.theme[3]};
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background: ${palette.theme[2]};
  }
  &:disabled {
    background: ${palette.theme[0]};
  }
`;

const StyledBtn2 = styled.button`
  width: 70px;
  margin-left: 10px;
  height: 45px;
  border: none;
  border-radius: 11px;
  background: ${palette.theme[3]};
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background: ${palette.theme[2]};
  }
  &:disabled {
    background: ${palette.theme[0]};
  }
`;
